export const CUSTOMER_SET = 'add-check.CUSTOMER_SET'
export const PHONE_SET = 'add-check.PHONE_SET'
export const SUMMARY_SET = 'add-check.SUMMARY_SET'
export const LOADING_SET = 'add-check.LOADING_SET'
export const SCREEN_SET = 'add-check.SCREEN_SET'
export const ERROR_SET = 'add-check.ERROR_SET'
export const MODAL_SET = 'add-check.MODAL_SET'
